import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  addControlledTournamentsAPI,
  fetchAdminsByTournamentIdAPI,
  removeControlledTournamentsAPI,
} from "./controlledTournamentsAPI";
import { showModal } from "../statusModal/statusModal";

const initialState = {
  byAdmin: {},
  fetchStatus: {},
  addStatus: {},
  removeStatus: {},
  error: null,
};

export const fetchAdminsByTournamentId = createAsyncThunk(
  "controlledTournaments/fetchControlledTournaments",
  async (adminId, { dispatch, rejectWithValue }) => {
    try {
      const response = await fetchAdminsByTournamentIdAPI(adminId);
      return { adminId, tournaments: response.data };
    } catch (error) {
      dispatch(
        showModal({ message: "حصل خطأ اثناء جلب البيانات", status: "error" })
      );
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch images"
      );
    }
  }
);

export const addControlledTournaments = createAsyncThunk(
  "controlledTournaments/addControlledTournaments",
  async (
    { adminId, tournamentIds, tournamentId },
    { dispatch, rejectWithValue }
  ) => {
    try {
      await addControlledTournamentsAPI(adminId, tournamentIds);
      dispatch(
        showModal({
          message: "تم اضافة البطولات الى اللاعب بنجاح",
          status: "success",
        })
      );
      dispatch(fetchAdminsByTournamentId(tournamentId));
      return { tournamentId };
    } catch (error) {
      dispatch(
        showModal({
          message: "حصل خطأ اثناء اضافة البطولات الى اللاعب",
          status: "error",
        })
      );
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch images"
      );
    }
  }
);

export const removeControlledTournaments = createAsyncThunk(
  "controlledTournamnets/removeControlledTournaments",
  async ({ adminId, tournamentIds, tournamentId }, { dispatch, rejectWithValue }) => {
    try {
      await removeControlledTournamentsAPI(adminId, tournamentIds);
      dispatch(
        showModal({
          message: "تم ازالة البطولات الى اللاعب بنجاح",
          status: "success",
        })
      );
      dispatch(fetchAdminsByTournamentId(tournamentId));
      return { tournamentId };
    } catch (error) {
      dispatch(
        showModal({
          message: "حصل خطأ اثناء اازالة البطولات من اللاعب",
          status: "error",
        })
      );
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch images"
      );
    }
  }
);

const controlledTournamentsSlice = createSlice({
  name: "controlledTournaments",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminsByTournamentId.pending, (state, action) => {
        state.fetchStatus[action.meta.arg] = "loading";
        state.error = null;
      })
      .addCase(fetchAdminsByTournamentId.fulfilled, (state, action) => {
        const { adminId, tournaments } = action.payload;
        state.fetchStatus[adminId] = "succeeded";
        state.byAdmin[adminId] = tournaments;
      })
      .addCase(fetchAdminsByTournamentId.rejected, (state, action) => {
        state.fetchStatus[action.meta.arg] = "failed";
        state.error = action.payload;
      })

      .addCase(addControlledTournaments.pending, (state, action) => {
        state.addStatus[action.meta.arg.tournamentId] = "loading";
        state.error = null;
      })
      .addCase(addControlledTournaments.fulfilled, (state, action) => {
        state.addStatus[action.payload.tournamentId] = "succeeded";
      })
      .addCase(addControlledTournaments.rejected, (state, action) => {
        state.addStatus[action.meta.arg.tournamentId] = "failed";
        state.error = action.payload;
      })

      .addCase(removeControlledTournaments.pending, (state, action) => {
        state.removeStatus[action.meta.arg.tournamentId] = "loading";
        state.error = null;
      })
      .addCase(removeControlledTournaments.fulfilled, (state, action) => {
        state.removeStatus[action.payload.tournamentId] = "succeeded";
      })
      .addCase(removeControlledTournaments.rejected, (state, action) => {
        state.removeStatus[action.meta.arg.tournamentId] = "failed";
        state.error = action.payload;
      });
  },
});

export default controlledTournamentsSlice.reducer;
